import { VListItemSubtitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItemSubtitle,[(_vm.isDueDate)?_c('span',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.value))]):_c('span',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }